<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动信息</span>
      </div>
      <div style="width: 500px;">
        <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px">
          <el-form-item label="活动名称" prop="name">
            <el-input v-model="ruleForm.name" placeholder="请输入活动名称" />
          </el-form-item>
          <el-form-item label="活动时间" prop="activityTime">
            <el-date-picker
              v-model="ruleForm.activityTime"
              type="daterange"
              range-separator="至"
              start-placeholder="请选择开始日期"
              end-placeholder="请选择结束日期"
              value-format="yyyy-MM-dd"
            />
          </el-form-item>
          <el-form-item label="活动说明" prop="description">
            <el-input v-model="ruleForm.description" type="textarea" :rows="4" placeholder="请输入活动说明" />
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">活动配置</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="configForm" :model="configForm" :rules="configRules" label-width="100px">
          <div v-for="(items,indexs) in configForm.coupons" :key="indexs" style="display:flex;align-items: flex-start;justify-content: space-between;">
            <el-card class="level-config">
              <div slot="header">
                <span>{{ numberfilter(indexs+1) }}级配置</span>
              </div>
              <el-form-item label="充值金额" :prop="'coupons.' + indexs + '.amount'" :rules="configRules.amountRule">
                <el-input v-model="items.amount" placeholder="请输入充值金额"><template slot="append">元</template></el-input>
              </el-form-item>
              <template v-for="(row,index) in items.coupons">
                <el-form-item
                  :key="index"
                  :label="'优惠券'+numberfilter(index+1)"
                  :prop="'coupons.' + indexs + '.coupons.'+ index"
                  :rules="configRules.couponsRule"
                  required
                >
                  <div class="d-flex">
                    <el-select v-model="row.couponId" filterable style="width: 200px;" placeholder="请选择优惠券" @change="(val)=>couponChange(val,index,indexs)">
                      <el-option v-for="item in allCoupon" :key="item.couponId" :label="item.couponName" :value="item.couponId" />
                    </el-select>
                    <el-input v-model="row.count" class="ml-20" style="width: 100px;" placeholder="请输入数量" />
                    <div class="ml-20">张</div>
                    <i class="icon-jia ml-20 el-icon-circle-plus-outline" @click="addCoupon(indexs,index)" />
                    <i
                      v-show="index!==0"
                      class="icon-jia ml-20 el-icon-remove-outline"
                      @click="delCoupon(indexs,index)"
                    />
                  </div>
                  <div class="d-flex currentStock">当前库存：{{ row.totalNum }}</div>
                </el-form-item>
              </template>
            </el-card>
            <p>
              <el-button v-show="configForm.coupons.length>1" type="danger" @click="delLevel(indexs)">删除</el-button>
              
              <el-button v-show="(configForm.coupons.length-1) === indexs && configForm.coupons.length<10" type="primary" style="margin-top:20px" @click="addLevel">增加</el-button>
            </p>
          </div>
          <el-form-item label="可参与次数" prop="times">
            <el-input v-model="configForm.times" placeholder="请输入当前活动用户可参与次数" />
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">可参与用户</span>
      </div>
      <div style="width: 600px;">
        <el-form ref="partakeForm" :model="partakeForm" :rules="partakeRules" label-width="100px">
          <el-form-item label="可参与用户" prop="userType">
            <el-radio-group v-model="partakeForm.userType">
              <el-radio v-for="(item, index) in userTypeItem" :key="index" :label="item.id">{{ item.label }}
              </el-radio>
            </el-radio-group>
            <!-- 选择机构 -->
            <div v-show="partakeForm.userType==='2'" class="border">
              <el-input v-model="filterMechanismText" placeholder="输入关键字进行过滤" />
              <el-tree
                ref="treeMechanism"
                :data="mechanismTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :props="treeDefaultProps"
                :default-checked-keys="partakeForm.mechanism"
                :filter-node-method="filterNode"
				:check-strictly="true"
              />
            </div>
            <!-- 选择标签 -->
            <div v-show="partakeForm.userType==='3'" class="border">
              <el-input v-model="filterTagText" placeholder="输入关键字进行过滤" />
              <el-tree
                ref="treeTag"
                :data="tagTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :default-checked-keys="partakeForm.tag"
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <div class="flexJCenter mt-25">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="onSubmit()">保存</el-button>
    </div>
  </div>
</template>

<script>
import {
  numberfilter
} from '@/utils/tool'
export default {
  data() {
    // 优惠券校验
    var validateCoupon = (rule, value, callback) => {
      const strP = /^[1-9]\d*$/
      if (!value.couponId) {
        callback(new Error(`请选择优惠券`))
      } else if (!value.count) {
        callback(new Error(`请输入数量`))
      } else if (!strP.test(value.count)) {
        callback(new Error(`请输入正整数`))
      } else if (value.totalNum && value.count > value.totalNum) {
        callback(new Error('优惠券数量大于库存数量'))
      } else {
        callback()
      }
    }
    var validateAmount = (rule, value, callback) => {
      const valTest = /^\d+(\.\d+)?$/
      const index = Number(rule.field.split('.')[1])
      if (!value && value !== 0) {
        callback(new Error('请输入充值金额'))
      } else if (!valTest.test(value)) {
        callback(new Error('请输入正数'))
      } else if (index > 0 && (Number(value) < Number(this.configForm.coupons[index - 1].amount) || Number(value) === Number(this.configForm.coupons[index - 1].amount))) {
        callback(new Error('充值金额必须高于上一等级金额'))
      } else {
        callback()
      }
    }
    return {
      dataId: '',
      treeDefaultProps: {
        children: 'children',
        label: 'name'
      },
      filterMechanismText: '', // 机构过滤
      filterTagText: '', // 标签过滤
      ruleForm: {
        name: '', // 活动名称
        activityTime: [], // 活动时间
        description: '' // 活动说明
      },
      rules: {
        name: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        activityTime: [{
          required: true,
          message: '请选择活动时间',
          trigger: 'blur'
        }],
        description: [{
          required: true,
          message: '请输入活动说明',
          trigger: 'blur'
        }]
      },
      // 所有的优惠券数据
      allCoupon: [],
      configForm: {
        coupons: [{
          amount: '', // 消费金额(充电电量) 表示达到多少
          coupons: [{
            couponId: '', // 选择的优惠券
            count: '', // 数量
            totalNum: ''// 优惠券库存
          }]
        }],
        times: ''
      },
      configRules: {
        amountRule: [{
          required: true,
          validator: validateAmount,
          trigger: 'blur'
        }],
        couponsRule: {
          validator: validateCoupon,
          trigger: ['blur', 'change']
        },
        times: [
          { required: true, message: '请输入可参与次数', trigger: 'blur' }
        ]
      },
      // 可参与用户字段的单选数据
      userTypeItem: [{
        label: '全部用户',
        id: '1'
      }, {
        label: '选择机构',
        id: '2'
      }, {
        label: '选择标签',
        id: '3'
      }],
      mechanismTreeData: [], // 机构树的全部数据
      tagTreeData: [], // 标签树的全部数据
      partakeForm: {
        userType: '1', // 可参与用户的单选字段
        mechanism: [], // 选择机构
        tag: [] // 选择标签
      },
      partakeRules: {
        userType: [{
          required: true,
          message: '请选择可参与用户',
          trigger: 'change'
        }]
      }
    }
  },
  watch: {
    filterMechanismText(val) {
      this.$refs.treeMechanism.filter(val)
    },
    filterTagText(val) {
      this.$refs.treeTag.filter(val)
    }
  },
  mounted() {
    // 接收数据后回显赋值
    this.$nextTick(() => {
      console.log('接收到的数据', this.$route.query)
      this.dataId = this.$route.query.id
      this.ruleForm = JSON.parse(JSON.stringify(this.$route.query.ruleForm))
      this.configForm = JSON.parse(JSON.stringify(this.$route.query.configForm))
      const newpartakeForm = JSON.parse(JSON.stringify(this.$route.query.partakeForm))
      this.partakeForm.userType = newpartakeForm.userType
      if (newpartakeForm.userType === '2') {
        this.partakeForm.mechanism = newpartakeForm.userValue.split(',')
        this.partakeForm.tag = []
      } else if (newpartakeForm.userType === '3') {
        this.partakeForm.mechanism = []
        this.partakeForm.tag = newpartakeForm.userValue.split(',')
      }
      this.loadTree()
      // 加载优惠券数据
      this.loadCoupon()
    })
  },
  methods: {
    numberfilter(num) {
      return numberfilter(num)
    },
    // 加载全部机构和标签数据
    loadTree() {
      this.$store.dispatch('form/handle', {
        url: '/setting/tree/org',
        data: { orgType: '1,3' },
        callback: resp => {
          this.mechanismTreeData = resp
        }
      })
      this.$store.dispatch('form/handle', {
        url: '/user/label/all',
        data: { orgType: '1,3', labelType: '0' },
        callback: resp => {
          this.tagTreeData = resp
        }
      })
      this.$forceUpdate()
    },
    // 加载优惠券数据
    loadCoupon() {
      const data = {
        pageNo: 1,
        pageSize: 1000,
        status: 0,
        hasStock: true
      }
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/getCouponList',
        data: data,
        method: 'post',
        callback: resp => {
          if (resp.list && resp.list.length > 0) {
            this.allCoupon = resp.list
            this.configForm.coupons.forEach(items => {
              items.coupons.forEach(item => {
                resp.list.forEach(ii => {
                  if (item.couponId === ii.couponId) {
                    item.totalNum = ii.stock
                  }
                })
              })
            })
            this.$forceUpdate()
          }
        }
      })
    },
    addLevel() {
      // 表单
      const data = {
        amount: '', // 充值金额表示达到多少
        coupons: [{
          couponId: '', // 选择的优惠券
          count: '', // 数量
          totalNum: '' // 优惠券库存
        }]
      }
      if (this.configForm.coupons.length < 10) {
        this.configForm.coupons.push(JSON.parse(JSON.stringify(data)))
      }
    },
    delLevel(index) {
      this.configForm.coupons.splice(index, 1)
    },
    // 优惠券选择赋值
    couponChange(val, index, indexs) {
      this.allCoupon.forEach(item => {
        if (item.couponId === val) {
          this.configForm.coupons[indexs].coupons[index].totalNum = item.stock
        }
      })
    },
    /**
       * 表单添加一行优惠券
       */
    addCoupon(val, index) {
      const data = {
        couponId: '', // 选择的优惠券
        count: '', // 数量
        totalNum: ''// 优惠券库存
      }
      this.configForm.coupons[val].coupons.splice(index + 1, 0, data)
    },
    /**
       * 删除删除一行优惠券
       */
    delCoupon(val, index) {
      this.configForm.coupons[val].coupons.splice(index, 1)
    },
    onSubmit() {
      let ruleFormBool = false
      this.$refs['ruleForm'].validate(valid => {
        ruleFormBool = valid
      })
      console.log(ruleFormBool)
      let configFormBool = false
      this.$refs['configForm'].validate(valid => {
        configFormBool = valid
      })
      console.log(configFormBool)
      let partakeFormBool = false
      this.$refs['partakeForm'].validate(valid => {
        partakeFormBool = valid
      })
      console.log(partakeFormBool)
      // 如果三个表单都验证正确
      if (ruleFormBool && configFormBool && partakeFormBool) {
        // 进入提交数据函数
        this.submitData()
      }
    },
    submitData() {
      const data = {
        type: 2,
        id: this.dataId,
        name: this.ruleForm.name,
        description: this.ruleForm.description,
        start: this.ruleForm.activityTime[0],
        end: this.ruleForm.activityTime[1],
        coupons: this.configForm.coupons,
        times: this.configForm.times,
        userType: this.partakeForm.userType,
        userValue: ''
      }
      let treeData = []
      if (this.partakeForm.userType === '2') {
        treeData = this.$refs.treeMechanism.getCheckedKeys()
      } else if (this.partakeForm.userType === '3') {
        treeData = this.$refs.treeTag.getCheckedKeys()
      }
      data.userValue = treeData.join(',')
      this.$store.dispatch('form/handle', {
        url: '/activity/save',
        data: data,
        method: 'post',
        callback: resp => {
          this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success',
            duration: 1500
          })
          this.$router.go(-1)
        }
      })
    },
    // 树的节点筛选
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    cancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
  .d-flex {
    display: flex;
  }

  .currentStock {
    height: 20px;
    align-items: center;
  }

  .ml-20 {
    margin-left: 20px;
  }

  .icon-jia {
    font-size: 22px;
    align-items: center;
    display: flex;
  }

  .border {
    border: 1px solid #EEEEEE;
    padding: 20px;
  }

  .flexJCenter {
    display: flex;
    justify-content: center;
  }

  .mt-25 {
    margin-top: 25px;
  }

  /deep/ .el-card.level-config {
    width:500px;
    margin: 10px 0;

    .el-card__header {
      font-size: 16px;
      padding: 10px 15px;
    }

    .el-card__body {
      padding: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/RechargeModify.vue